import { Component } from "@angular/core";
import {
  ClientPromiseLookupService,
  UserPromiseLookupService,
  ClientActionPromiseService,
} from "shared/cubiq-services";
import { ClientContactImpl, NotificationMethod, ClientImpl } from "shared/cubiq-model-multi-asset";
import { TranslateService } from "@ngx-translate/core";
import { GoldenLayoutPopout } from "../golden-layout/golden-layout-popout";
import { BfxBlotterOrdersActionService } from "../bfx-blotter-orders/bfx-blotter-orders-action.service";
import { emailFormatValidator } from "../../shared/validators/email-format-validator";

enum BfxContactEditComponentFields {
  Client,
  ContactName,
  Desk,
  Mobile,
  SMS,
  Email,
}

enum BfxContactEditComponentValidationResult {
  NotValidated,
  Valid,
  Invalid,
}

const REGEX_PHONE = /^\+?[0-9]{3,}$/i;

const MANDATORY_FIELDS: Array<BfxContactEditComponentFields> = [
  BfxContactEditComponentFields.ContactName,
];
const OPTIONAL_FIELDS: Array<BfxContactEditComponentFields> = [
  BfxContactEditComponentFields.SMS,
  BfxContactEditComponentFields.Email,
];
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-contact-edit",
  templateUrl: "./html/bfx-contact-edit.html",
  standalone: false,
})
export class BfxContactEditComponent {
  public parentPopup: GoldenLayoutPopout;

  public clientContact: ClientContactImpl;

  public client: ClientImpl;

  public callback: any;

  public callbackClose: any;

  public locked: boolean = false;

  public valid: any = {};

  public notifyEntryEmail: boolean;

  public notifyEntrySMS: boolean;

  public notifyExpiryEmail: boolean;

  public notifyExpirySMS: boolean;

  public notifyFillEmail: boolean;

  public notifyFillSMS: boolean;

  public notifyModifyEmail: boolean;

  public notifyModifySMS: boolean;

  public notifyCancelEmail: boolean;

  public notifyCancelSMS: boolean;

  constructor(
    public clientService: ClientPromiseLookupService,
    public userService: UserPromiseLookupService,
    public translationService: TranslateService,
    public blotterOrderService: BfxBlotterOrdersActionService,
    public clientActionService: ClientActionPromiseService,
  ) {}

  public glInit(data: any, container: any, state: any): void {
    this.clientContact = Object.assign(
      new ClientContactImpl(),
      data.clientContact != null ? data.clientContact : new ClientContactImpl(),
    );
    this.client = data.client;
    this.clientContact.clientCd = this.client.clientId;
    this.callback = data.callback;
    this.callbackClose = data.callbackClose;

    if (data.clientContact != null) {
      this.notifyEntryEmail =
        this.clientContact.notifyEntry == NotificationMethod.EMAIL_ONLY ||
        this.clientContact.notifyEntry == NotificationMethod.EMAIL_AND_SMS;
      this.notifyEntrySMS =
        this.clientContact.notifyEntry == NotificationMethod.SMS_ONLY ||
        this.clientContact.notifyEntry == NotificationMethod.EMAIL_AND_SMS;
      this.notifyExpiryEmail =
        this.clientContact.notifyExpiry == NotificationMethod.EMAIL_ONLY ||
        this.clientContact.notifyExpiry == NotificationMethod.EMAIL_AND_SMS;
      this.notifyExpirySMS =
        this.clientContact.notifyExpiry == NotificationMethod.SMS_ONLY ||
        this.clientContact.notifyExpiry == NotificationMethod.EMAIL_AND_SMS;
      this.notifyFillEmail =
        this.clientContact.notifyFill == NotificationMethod.EMAIL_ONLY ||
        this.clientContact.notifyFill == NotificationMethod.EMAIL_AND_SMS;
      this.notifyFillSMS =
        this.clientContact.notifyFill == NotificationMethod.SMS_ONLY ||
        this.clientContact.notifyFill == NotificationMethod.EMAIL_AND_SMS;
      this.notifyModifyEmail =
        this.clientContact.notifyModify == NotificationMethod.EMAIL_ONLY ||
        this.clientContact.notifyModify == NotificationMethod.EMAIL_AND_SMS;
      this.notifyModifySMS =
        this.clientContact.notifyModify == NotificationMethod.SMS_ONLY ||
        this.clientContact.notifyModify == NotificationMethod.EMAIL_AND_SMS;
      this.notifyCancelEmail =
        this.clientContact.notifyCancel == NotificationMethod.EMAIL_ONLY ||
        this.clientContact.notifyCancel == NotificationMethod.EMAIL_AND_SMS;
      this.notifyCancelSMS =
        this.clientContact.notifyCancel == NotificationMethod.SMS_ONLY ||
        this.clientContact.notifyCancel == NotificationMethod.EMAIL_AND_SMS;

      this.validateAll();
    }
  }

  setParentPopup(parentPopup: GoldenLayoutPopout) {
    this.parentPopup = parentPopup;
    this.parentPopup.setShowDock(false);
    this.parentPopup.setShowRefresh(false);
  }

  save() {
    if (this.validateAll()) {
      this.clientContact.notifyEntry =
        this.notifyEntryEmail && this.notifyEntrySMS
          ? NotificationMethod.EMAIL_AND_SMS
          : this.notifyEntryEmail
            ? NotificationMethod.EMAIL_ONLY
            : this.notifyEntrySMS
              ? NotificationMethod.SMS_ONLY
              : NotificationMethod.NONE;
      this.clientContact.notifyExpiry =
        this.notifyExpiryEmail && this.notifyExpirySMS
          ? NotificationMethod.EMAIL_AND_SMS
          : this.notifyExpiryEmail
            ? NotificationMethod.EMAIL_ONLY
            : this.notifyExpirySMS
              ? NotificationMethod.SMS_ONLY
              : NotificationMethod.NONE;
      this.clientContact.notifyFill =
        this.notifyFillEmail && this.notifyFillSMS
          ? NotificationMethod.EMAIL_AND_SMS
          : this.notifyFillEmail
            ? NotificationMethod.EMAIL_ONLY
            : this.notifyFillSMS
              ? NotificationMethod.SMS_ONLY
              : NotificationMethod.NONE;
      this.clientContact.notifyModify =
        this.notifyModifyEmail && this.notifyModifySMS
          ? NotificationMethod.EMAIL_AND_SMS
          : this.notifyModifyEmail
            ? NotificationMethod.EMAIL_ONLY
            : this.notifyModifySMS
              ? NotificationMethod.SMS_ONLY
              : NotificationMethod.NONE;
      this.clientContact.notifyCancel =
        this.notifyCancelEmail && this.notifyCancelSMS
          ? NotificationMethod.EMAIL_AND_SMS
          : this.notifyCancelEmail
            ? NotificationMethod.EMAIL_ONLY
            : this.notifyCancelSMS
              ? NotificationMethod.SMS_ONLY
              : NotificationMethod.NONE;

      this.callback(this.clientContact);
      this.parentPopup.close();
    }
  }

  cancel() {
    this.parentPopup.close();
  }

  isSaveEnabled(): boolean {
    let mandatory: boolean = MANDATORY_FIELDS.every(
      (field: BfxContactEditComponentFields) =>
        this.valid[field] == BfxContactEditComponentValidationResult.Valid,
    );
    let optional: boolean = OPTIONAL_FIELDS.every(
      (field: BfxContactEditComponentFields) =>
        this.valid[field] != BfxContactEditComponentValidationResult.Invalid,
    );
    return mandatory && optional;
  }

  validateAll(): boolean {
    let valid: boolean = true;

    for (let i: number = 1; i <= 5; i++) {
      valid = this.validate(i) && valid;
    }

    return valid;
  }

  validate(fieldNo: BfxContactEditComponentFields): boolean {
    let valid: boolean = true;
    let state = BfxContactEditComponentValidationResult.NotValidated;

    switch (fieldNo) {
      case BfxContactEditComponentFields.ContactName:
        valid =
          this.clientContact.contactNameTxt != null &&
          this.clientContact.contactNameTxt.trim().length > 0;
        state = valid
          ? BfxContactEditComponentValidationResult.Valid
          : BfxContactEditComponentValidationResult.Invalid;
        break;
      case BfxContactEditComponentFields.Desk:
        if (this.clientContact.deskTxt != null && this.clientContact.deskTxt.length > 0) {
          state = BfxContactEditComponentValidationResult.Valid;
        }
        break;
      case BfxContactEditComponentFields.SMS:
        if (this.clientContact.smsTxt != null && this.clientContact.smsTxt.length > 0) {
          valid = this.phoneValid(this.clientContact.smsTxt);
          state = valid
            ? BfxContactEditComponentValidationResult.Valid
            : BfxContactEditComponentValidationResult.Invalid;
        } else if (this.clientContact.smsTxt == null || this.clientContact.smsTxt.length <= 0) {
          this.uncheckSmsRelatedCheckboxes();
        }
        break;
      case BfxContactEditComponentFields.Mobile:
        if (this.clientContact.mobileTxt != null && this.clientContact.mobileTxt.length > 0) {
          valid = this.phoneValid(this.clientContact.mobileTxt);
          state = valid
            ? BfxContactEditComponentValidationResult.Valid
            : BfxContactEditComponentValidationResult.Invalid;
        }
        break;
      case BfxContactEditComponentFields.Email:
        if (this.clientContact.emailTxt != null && this.clientContact.emailTxt.length > 0) {
          valid = this.emailValid();
          state = valid
            ? BfxContactEditComponentValidationResult.Valid
            : BfxContactEditComponentValidationResult.Invalid;
        } else if (this.clientContact.emailTxt == null || this.clientContact.emailTxt.length <= 0) {
          this.uncheckEmailRelatedCheckboxes();
        }
        break;
      default:
        // TODO check for null/length==0
        state = BfxContactEditComponentValidationResult.Valid;
        break;
    }

    this.valid[fieldNo] = state;

    return state != BfxContactEditComponentValidationResult.Invalid;
  }

  emailValid(): boolean {
    return emailFormatValidator(this.clientContact.emailTxt);
  }

  smsValid(): boolean {
    return this.phoneValid(this.clientContact.smsTxt);
  }

  phoneValid(phoneEntry: string): boolean {
    return phoneEntry != null && REGEX_PHONE.test(phoneEntry);
  }

  public onClose(event: any): void {
    if (this.callbackClose) {
      this.callbackClose(event);
    }
  }

  private uncheckEmailRelatedCheckboxes() {
    this.notifyEntryEmail = false;
    this.notifyExpiryEmail = false;
    this.notifyFillEmail = false;
    this.notifyModifyEmail = false;
    this.notifyCancelEmail = false;
  }

  private uncheckSmsRelatedCheckboxes() {
    this.notifyEntrySMS = false;
    this.notifyExpirySMS = false;
    this.notifyFillSMS = false;
    this.notifyModifySMS = false;
    this.notifyCancelSMS = false;
  }
}
